import React from "react";

const cards = [
  { key: "total", label: "Total", accent: "primary", icon: "bi-people" },
  { key: "activos", label: "Activos", accent: "success", icon: "bi-person-check" },
  { key: "inactivos", label: "Inactivos", accent: "secondary", icon: "bi-person-dash" },
  { key: "sinRol", label: "Sin rol", accent: "warning", icon: "bi-person-lock" },
  { key: "sinCentro", label: "Sin centro", accent: "dark", icon: "bi-building-x" },
];

export default function UsuariosSummary({ resumen = {}, onQuickFilter, activeKey }) {
  const handleKey = (key) => onQuickFilter?.(key);

  return (
    <div className="management-card usuarios-summary-card mb-4">
      <div className="usuarios-summary-grid">
        {cards.map((card) => {
          const isActive = activeKey === card.key;
          const accentClass = card.accent ? `accent-${card.accent}` : "";
          return (
            <div key={card.key}>
              <div
                className={`management-stat-card usuarios-summary-card-item h-100 ${accentClass} ${isActive ? "active" : ""}`}
                role="button"
                tabIndex={0}
                onClick={() => handleKey(card.key)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleKey(card.key);
                  }
                }}
              >
                <div className="management-stat-icon">
                  <i className={`bi ${card.icon}`} />
                </div>
                <div>
                  <p className="management-stat-label mb-1">{card.label}</p>
                  <div className="management-stat-value">{resumen[card.key] ?? 0}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
